import { APIResponse, Language, TextGroup } from '../../@types';
import { makeAPICall } from './clientHelpers/makeAPICall';

export const textClient = {
  get: async (
    group: TextGroup,
    language: Language
  ): Promise<APIResponse<any>> => {
    const { notModified, data, error } = await makeAPICall({
      method: 'GET',
      url: `/texts/${group}`,
      headers: {
        'Accept-Language': language,
      },
    });
    return {
      notModified,
      data,
      error,
    };
  },
};
